import { WalletController } from "@api/WalletController";
import { create } from "zustand";
import { IAsset } from "@api/IWalletController";
import { initialAssets } from "./assets.store";

const initialAsset: IAsset = initialAssets[0];

interface ISendStore {
    asset: IAsset;
    recipient: string | null;
    amount: string | null;
    memo: string | null;
    isLoading: boolean;

    setAsset(asset: IAsset): void;
    setRecipient(recipient: string): void;
    setMemo(memo: string): void;
    setAmount(amount: string): void;
}

export const useSendStore = create<ISendStore>()((set, get) => ({
    asset: initialAsset,
    amount: null,
    recipient: null,
    memo: null,
    isLoading: false,

    setAsset: (asset: IAsset) => set({ asset }),
    setRecipient: (recipient: string) => set({ recipient }),
    setMemo: (memo: string) => set({ memo }),
    setAmount: (amount: string) => set({ amount }),
}));
